import _ from 'lodash'

import { Index } from 'services/standard_client'

export function getIndexItemIdString(indexItem: Index): string {
  return _.isFinite(_.toNumber(indexItem.id)) ? indexItem.id : ''
}
